export default __webpack_public_path__ + "static/media/JAGUAR.c1a1fdd4.png";